module.exports = __webpack_public_path__ + "66db13b7.svg";